import RecentreControl from './RecentreControl';

export default RecentreControl;
